export const errorMap = {
  invalidRangeOverOneMonth: 'The date range can’t exceed 1 month.'
};
